var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBronze(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_368_14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 8C4 3.58172 7.58172 0 12 0H60C64.4183 0 68 3.58172 68 8V56C68 60.4183 64.4183 64 60 64H12C7.58172 64 4 60.4183 4 56V8Z",
    fill: "url(#paint0_linear_368_14)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_368_14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.7963 45.4296L38.0665 55.3005C36.7728 56.0666 35.1722 56.0666 33.8786 55.3005L17.1487 45.4296C15.866 44.6745 15.0876 43.2866 15.0876 41.7877V21.9681C15.0876 20.4691 15.877 19.0812 17.1487 18.3262L33.5387 8.6662C35.0407 7.77793 36.9044 7.77793 38.4173 8.6662L54.7963 18.3373C56.079 19.0923 56.8574 20.4802 56.8574 21.9792V41.7988C56.8684 43.2977 56.079 44.6745 54.7963 45.4296Z",
    fill: "#FEEBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1715 43.9196L37.0799 53.8016C36.3892 54.2013 35.5451 54.2013 34.8544 53.8016L17.7628 43.9196C17.0721 43.5199 16.6445 42.787 16.6445 41.9876V22.2124C16.6445 21.413 17.0721 20.6802 17.7628 20.2805L34.8544 10.3984C35.5451 9.9987 36.3892 9.9987 37.0799 10.3984L54.1715 20.2805C54.8622 20.6802 55.2898 21.413 55.2898 22.2124V41.9876C55.2788 42.787 54.8622 43.5199 54.1715 43.9196Z",
    fill: "#FFFDF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0055 56C35.3038 56 34.5912 55.8112 33.9663 55.4448L17.0392 45.5517C15.7784 44.8078 15 43.4309 15 41.9653V22.1568C15 20.6801 15.7784 19.3144 17.0392 18.5704L33.9554 8.6773C35.2161 7.94448 36.7839 7.94448 38.0446 8.6773L54.9608 18.5815C56.2216 19.3144 57 20.6912 57 22.1679V41.9764C57 43.4532 56.2216 44.8189 54.9608 45.5628L38.0446 55.467C37.4197 55.8112 36.7071 56 36.0055 56ZM36.0055 10.5649C35.7204 10.5649 35.4244 10.6426 35.1723 10.787L18.2451 20.6912C17.7298 20.991 17.4119 21.5572 17.4119 22.1568V41.9653C17.4119 42.5649 17.7298 43.1312 18.2451 43.431L35.1613 53.3352C35.6766 53.635 36.3234 53.635 36.8387 53.3352L53.7549 43.431C54.2702 43.1312 54.5881 42.5649 54.5881 41.9653V22.1568C54.5881 21.5572 54.2702 20.991 53.7549 20.6912L36.8387 10.787C36.5865 10.6426 36.2905 10.5649 36.0055 10.5649Z",
    fill: "url(#paint1_linear_368_14)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8316 43.5975L37.1895 53.2241C36.5207 53.6127 35.6875 53.6127 35.0187 53.2241L18.3766 43.5975C17.7079 43.2088 17.2913 42.4871 17.2913 41.721V22.4677C17.2913 21.6904 17.7079 20.9798 18.3766 20.5912L35.0187 10.9646C35.6875 10.5759 36.5207 10.5759 37.1895 10.9646L53.8316 20.5912C54.5003 20.9798 54.9169 21.7015 54.9169 22.4677V41.721C54.9169 42.4871 54.5003 43.2088 53.8316 43.5975Z",
    fill: "#FFCFB5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2068 42.9425L36.5646 52.7579C36.2906 52.9245 35.9507 52.9245 35.6766 52.7579L19.0455 42.9425C18.7714 42.7871 18.6069 42.4873 18.6069 42.1764V22.5233C18.6069 22.2125 18.7714 21.9127 19.0455 21.7572L35.6876 11.9418C35.9617 11.7753 36.3015 11.7753 36.5756 11.9418L53.2177 21.7572C53.4918 21.9127 53.6563 22.2125 53.6563 22.5233V42.1764C53.6453 42.4984 53.4809 42.7871 53.2068 42.9425Z",
    fill: "url(#paint2_linear_368_14)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.39
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.1371 52.0805C35.8959 52.0805 35.6437 52.0138 35.4245 51.8806L19.8239 42.5982C19.3963 42.3428 19.1332 41.8764 19.1332 41.3768V22.7675C19.1332 22.2678 19.3963 21.8015 19.8239 21.5461L35.4245 12.2526C35.863 11.9972 36.4002 11.9972 36.8387 12.2526L52.4394 21.5461C52.8669 21.8015 53.13 22.2678 53.13 22.7675V41.3657C53.13 41.8653 52.8669 42.3317 52.4394 42.5871L36.8387 51.8806C36.6195 52.0138 36.3783 52.0805 36.1371 52.0805ZM20.8873 41.1658L36.1261 50.2484L51.365 41.1658V22.9785L36.1261 13.8959L20.8873 22.9785V41.1658Z",
    fill: "url(#paint3_linear_368_14)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M36.0493 53.4351C35.8191 53.4351 35.5888 53.3796 35.3805 53.2574L18.2012 43.2644C17.7846 43.0201 17.5215 42.5649 17.5215 42.0763V22.1235C17.5215 21.6349 17.7846 21.1797 18.2012 20.9354L35.3805 10.9535C35.7971 10.7092 36.3124 10.7092 36.729 10.9535L53.9083 20.9354C54.3249 21.1797 54.588 21.6349 54.588 22.1235V42.0763C54.588 42.5649 54.3249 43.0201 53.9083 43.2644L36.729 53.2463C36.5207 53.3685 36.2795 53.4351 36.0493 53.4351ZM19.0563 41.9764L36.0493 51.8473L53.0422 41.9764V22.2345L36.0493 12.3525L19.0563 22.2345V41.9764Z",
    fill: "url(#paint4_linear_368_14)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6492 27.3755L44.4362 27.5531L36.3124 40.8994L28.6492 27.3755Z",
    fill: "#EECFC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0658 27.6531L44.0086 27.8196L36.3234 40.4553L29.0658 27.6531Z",
    fill: "#FEBB99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6492 27.3755L25.5795 25.7988L36.2028 43.9418L36.3124 40.8995L28.6492 27.3755Z",
    fill: "url(#paint5_linear_368_14)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4362 27.5532L47.4401 25.9099L25.5795 25.7988L28.6492 27.3755L44.4362 27.5532Z",
    fill: "url(#paint6_linear_368_14)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2028 43.9418L47.44 25.9099L44.4361 27.5532L36.3124 40.8995L36.2028 43.9418Z",
    fill: "url(#paint7_linear_368_14)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_368_14",
    x: 0,
    y: 0,
    width: 72,
    height: 72,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_368_14"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_368_14",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_368_14",
    x: 11,
    y: 8,
    width: 50,
    height: 56,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_368_14"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_368_14",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_368_14",
    x1: 36,
    y1: 0,
    x2: 36,
    y2: 64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF8C69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEBB99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_368_14",
    x1: 25.494,
    y1: 13.6262,
    x2: 46.9154,
    y2: 50.2608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8B097"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3128,
    stopColor: "#E99C79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6369,
    stopColor: "#D47B56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B85C29"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_368_14",
    x1: 34.6621,
    y1: 20.2689,
    x2: 39.0904,
    y2: 55.9054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3B785"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2658,
    stopColor: "#ECA973"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6225,
    stopColor: "#D58049"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D07741"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_368_14",
    x1: 36.1332,
    y1: 12.0601,
    x2: 36.1332,
    y2: 52.0816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E89E67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7318,
    stopColor: "#B95A2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B86434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_368_14",
    x1: 26.8135,
    y1: 15.901,
    x2: 45.6403,
    y2: 48.0982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF7B55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2291,
    stopColor: "#E4895C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4497,
    stopColor: "#EB9565"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7961,
    stopColor: "#F2A475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC8A9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_368_14",
    x1: 28.4748,
    y1: 28.4692,
    x2: 33.5937,
    y2: 38.3353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1983,
    stopColor: "#C06A43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4722,
    stopColor: "#D27A4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7458,
    stopColor: "#DF8656"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8775,
    stopColor: "#E8945F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED9B64"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_368_14",
    x1: 25.5661,
    y1: 26.4801,
    x2: 47.4268,
    y2: 26.7542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1983,
    stopColor: "#FFE3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5473,
    stopColor: "#F9C5A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7458,
    stopColor: "#F6B99C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8849,
    stopColor: "#F5AF8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4AA85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_368_14",
    x1: 43.7988,
    y1: 29.634,
    x2: 38.6077,
    y2: 39.5578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1983,
    stopColor: "#D0804F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3555,
    stopColor: "#D58754"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7458,
    stopColor: "#DF945F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864,
    stopColor: "#EA9E65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1A569"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBronze);
export default __webpack_public_path__ + "static/media/bronze.c8d76abcee1630f40ebc57ebad5fe4d3.svg";
export { ForwardRef as ReactComponent };